<template>
    <div style="height: 100%;">
        <v-container fluid style="overflow: auto; height: 100% !important; padding-bottom: 0px;">
            <v-data-table
            :headers="headers"
            :items="historyList"
            sort-by=""
            class="elevation-0"
            id="tableTest"
            height="75%"                                 
            >
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title class="font-weight-bold"
                        >Scan History
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.start_time`]="{ item }">
                    {{ formatDateTime(item.start_time) }}
                </template>
                <template v-slot:[`item.end_time`]="{ item }">
                    {{ formatDateTime(item.end_time) }}
                </template>
                <template v-slot:[`item.job`]="{item}">
                    <!-- Pending or Running일 때 status 표시 -->
                    <v-chip
                    v-if="item.job == 'Pending' || item.job =='Running'"
                    :color="statusColor(item.job)"
                    :style="statusBackColor(item.job)"
                    small
                    style="color: white !important; justify-content: center !important;"
                    >
                        <v-icon
                        small
                        class="mr-1"
                        v-if="stopId.includes(item.id) && item.job =='Pending'"
                        style="animation: spin 1s linear infinite;"
                        >
                            mdi-progress-helper
                        </v-icon>
                        <v-icon 
                        small
                        class="mr-1"
                        v-if="item.job == 'Running'"
                        style="animation: spin 1s linear infinite;"
                        >
                            mdi-{{ statusIcon(item.job) }}
                        </v-icon>
                        {{ changeStatus(item.job, item.id) }}
                    </v-chip>

                    <!-- 배경 없는 status 표시- complete, error etc.-->
                    <v-chip
                    v-else
                    :color="statusColor(item.job)"
                    small
                    outlined
                    style="justify-content: center !important; border: transparent !important;"
                    >
                        <v-icon
                        small
                        class="mr-1"
                        >
                            mdi-{{ statusIcon(item.job) }}
                        </v-icon>
                        {{ changeStatus(item.job, item.id) }}
                    </v-chip>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                    <!-- <v-btn
                    v-if="item.job == 'Running'"
                    @click="scanStop(item, $event)"
                    > STOP </v-btn> -->
                    <v-btn
                    v-if="item.current_status=='Scan_finish'"
                    color="blue-grey lighten-4"
                    small
                    elevation=""
                    @click="viewItem(item.id)"
                    >VIEW</v-btn>
                    <v-btn
                    v-if="item.job == 'Running' || item.job =='Pending'"
                    color="red"
                    style="color: white !important;"
                    small
                    elevation=""
                    :disabled = "stopId.includes(item.id)" 
                    @click="scanStop(item)"
                    > STOP </v-btn>
                </template>
            </v-data-table>
            <!-- <div class="text-center">
                <v-dialog v-model="dialog" v-if="selectedItem" :fullscreen="$vuetify.breakpoint.width<=960?true:false" :width="$vuetify.breakpoint.width<600?'':'80%'">
                <scan-result-vue
                    :result="alerts"
                    :show-close-button="true"
                    @close="dialog = false"
                    :is-history-page="true"
                    :infoObj="infoObj"
                    :owaspData="owaspData"
                ></scan-result-vue>
                </v-dialog>
            </div>  -->
        </v-container>
    </div>
</template>

<script>
// import EventBus from '@/plugins/EventBus';
import axios from 'axios';

export default {
    name: "ScanHistory",
     data: () => ({
        historyList:[],
        headers: [
            { text: "No", value: "no", align: "center" },
            { text: "URL", value: "scan_url", sortable: false, align: "center" },
            { text: "Start Time", value: "start_time", align: "center" },
            { text: "End Time", value: "end_time", align: "center" },
            { text: "Status", value: "job", sortable: false, align: "center" },
            { text: "Actions", value: "action", sortable: false, align: "center" },
        ],
        queueInterval: null,
        jobQueue:[],
        prevQueue: "",
        prevCurScanId: -1,
        stopBtnDisabled: false,
        stopId: [],
     }),
     created(){
        this.fetchHistory();
        console.log("scanHistory page");
     },
     beforeDestroy(){
        clearInterval(this.queueInterval)
     },
     methods:{
        fetchHistory: async function(){
            try {
                const response = await axios.post(
                    `${this.$apiUrl}/webscan/history`,
                    {},
                    { withCredentials: true }
                );
                const result = response.data.reduce((acc, item, index) => {

                    const newItem = {
                        ...item,
                        no: index + 1,
                        job: ['null', 'Abnormal'].includes(item.job) ? 'Error' :  item.job
                    };

                    acc.list.push(newItem);

                    if (newItem.job === "Running" || newItem.job === "Pending") {
                        if(newItem.job ==="Running")this.prevCurScanId = newItem.id
                        acc.ids.push(newItem.id);
                    }

                    return acc;

                }, { list: [], ids: [] });

                this.historyList = result.list.sort((a, b) => b.id - a.id);
                this.prevQueue = result.ids.join(",");


                this.$nextTick(()=>{
                    if(this.historyList.length>0){

                        if(this.queueInterval){
                            clearInterval(this.queueInterval)
                        }
                        this.queueInterval = setInterval(async ()=>{
                            try{
                                const res = await axios.post(`${this.$apiUrl}/webscan/jobqueue`, {}, { withCredentials: true })
                                const { queue, current_scan_id } = res.data;

                                const queueChanged = queue !==this.prevQueue;
                                const scanChanged = current_scan_id !==this.prevCurScanId;

                                if(queueChanged || scanChanged){
                                    console.log("queue changed:", this.prevQueue, "→", queue);
                                    console.log("scan changed:", this.prevCurScanId, "→", current_scan_id);

                                    const prevArr = this.prevQueue?this.prevQueue.split(","):[];
                                    const newArr = queue? queue.split(","): [];

                                    const union = [...new Set([...prevArr, ...newArr])]

                                    const diffArr = union.join(",")
                                    
                                    this.updateStatus(diffArr);
                                    this.prevQueue = queue;
                                    this.prevCurScanId = current_scan_id;
                                }
                                     

                            }catch(e){
                                console.error("jobqueue error", e);
                            }

                            },10000);

                    }
                })
            
            } catch (error) {
                console.error("Error fetching scan report:", error);
            }
        },
        updateStatus(str){
            console.log("updateStatus arr");
            axios.post(`${this.$apiUrl}/webscan/jobstatus`, {scan_id_arr: str}, { withCredentials: true }).then((res)=>{
                if(res.data){
                    console.log("res.data")
                    console.log(res.data)
                    // const historyArr = this.historyList;
                    // res.data.forEach(x => {
                    //     const index = historyArr.findIndex(b => b.id == x.id);
                    //    if(index !== -1){
                    //     historyArr[index] = x;
                    //    }
                    // })
                    // this.historyList = historyArr;
                    const updateMap = new Map(res.data.map(x => [x.id, x]));

                    this.historyList = this.historyList.map(item => {
                        if(updateMap.has(item.id)){
                            return {
                                ...item,
                                ...updateMap.get(item.id)
                            };
                        }
                        return item;
                    });
                }
                if(res.error){
                    clearInterval(this.queueInterval);
                }
            })

        },
        formatDateTime(dateTime) {
            const date = new Date(dateTime);
            const options = {
                weekday: "short",
                year: "numeric",
                month: "short",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
            };
            return dateTime==null || dateTime =='0' ? '-':date.toLocaleDateString("en-US", options);
        },
        viewItem:function(id){
            console.log(id)
            this.$router.push({
                name: 'ScanReport',
                params:{
                    id: id
                }
            })
        },
        changeStatus:function(status, id){
            switch(status){
                case 'Finish': return 'Complete';
                case 'Stop': return 'Stopped';
                case 'Error': return status;
                case 'Running': return this.stopId.includes(id)?'Stopping':status;
                case 'Pending': return this.stopId.includes(id)?'Stopping':status;
                case 'Auth_failed': return 'Auth Failed';
            }
        },
        statusColor:function(status){
            const status1 = status == 'Auth_failed'? 'Error': status;
            switch(status1){
                case 'Finish': return 'rgb(76,175,80)';
                case 'Stop': return 'rgb(244,67,54)';
                case 'Error': return 'orange darken-2';
                case 'Running': return 'blue darken-3';
                case 'Pending': return '#90A4AE';
            }
        },
        statusBackColor:function(status){
            var str='background-color: ';
            const status1 = status == 'Auth_failed'? 'Error': status;
            switch(status1){
                case 'Finish': str+='rgba(76,175,80,0.1)'; break;
                case 'Stop': str+= 'rgba(244,67,54, 0.1)';break;
                case 'Error': str+= 'rgba(245,124,0, 0.1)'; break;
                case 'Running': str+= '#3F51B5'; break;
                case 'Pending':  str+=  '#90A4AE'; break;
            }
            return str+'!important;';
        },
        statusIcon(status){
            const status1 = status == 'Auth_failed'? 'Error': status;
            switch(status1){
                case 'Finish': return 'check-circle-outline';
                case 'Stop': return 'stop-circle-outline';
                case 'Error': return 'alert-outline';
                case 'Running': return 'progress-helper';
                case 'Pending': return 'clock-outline';
            }
        },
        scanStop: async function(item){
            // EventBus.$emit("stop-scan");\
            this.stopId = [...this.stopId, item.id];
            console.log("this.stopId")
            console.log(this.stopId)
            console.log("item.id")
            console.log(item.id)
            if(item.id){
                const response = await axios.post(`${this.$apiUrl}/webscan/stop`, { scan_id: item.id }, { withCredentials: true });
                if(response.data.result){
                    console.log("success");
                    // this.stopId = this.stopId.filter(id => id !== item.id);
                }else{
                    console.error("failed to stop scan, scan id:"+item.id);
                }
            }else{
                console.error("No scan ID available to stop.")
            }
        }
     }
}
</script>

<style>
@keyframes spin {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
</style>